import { motion } from "framer-motion";
import logo from "../assets/SolidLogo1.svg";

const NAV_HEIGHT = 80;

function scrollTo(id) {
  const el = document.getElementById(id);
  if (!el) return;
  const top = el.getBoundingClientRect().top + window.scrollY - NAV_HEIGHT;
  window.scrollTo({ top, behavior: "smooth" });
}

function Nav() {
  const links = [
    { label: "How it Works", id: "how-it-works" },
    { label: "Trust", id: "trust" },
    { label: "Audience", id: "audience" },
    { label: "Benefits", id: "benefits" },
  ];

  return (
    <motion.nav
      className="fixed top-0 w-full z-50 bg-white/80 backdrop-blur-xl shadow-sm"
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <div className="flex justify-between items-center px-8 py-4 max-w-7xl mx-auto font-headline font-bold tracking-tight">
        <button
          className="flex items-center gap-2"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          <img src={logo} alt="SOLID" className="h-8 w-auto" />
          <span className="text-2xl font-black tracking-tighter text-slate-900">SOLID</span>
        </button>

        <div className="hidden md:flex space-x-8 items-center">
          {links.map(({ label, id }) => (
            <button
              key={id}
              className="text-slate-600 hover:text-slate-900 transition-colors"
              onClick={() => scrollTo(id)}
            >
              {label}
            </button>
          ))}
        </div>

        <button
          className="bg-[#1bc9d1] text-white px-6 py-2.5 rounded-xl text-sm hover:opacity-80 transition-all duration-300 active:scale-95"
          onClick={() => scrollTo("download")}
        >
          Download
        </button>
      </div>
    </motion.nav>
  );
}

export default Nav;
